import React, { Component } from 'react';

class PatientMedicationBreadcrumb extends Component {
    render() {
        const { patientName } = this.props;
        
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Patient Menu
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Patient Medications
                                    </li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">
                                <i className="fas fa-pills mr-2"></i>
                                {patientName ? `${patientName} - Medications` : 'Patient Medications'}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PatientMedicationBreadcrumb;